import { ConfigProvider, Tooltip, Typography } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { useEllipsizeTextByParent } from 'hooks/useEllipsizeTextByParent';

interface EllipsizeTextProps {
  text: string;
  className?: string;
  placement?: TooltipPlacement;
  arrow?: boolean;
  withPointerEvents?: boolean;
}

const EllipsizeText = ({
  text,
  className,
  placement = 'topLeft',
  arrow = true,
  withPointerEvents = false,
}: EllipsizeTextProps) => {
  const { elemRef, isExceeded } = useEllipsizeTextByParent();

  if (isExceeded) {
    return (
      <ConfigProvider
        theme={{
          components: {
            Tooltip: {
              colorBgSpotlight: '#424242',
              algorithm: true,
            },
          },
        }}
      >
        <Tooltip
          overlayStyle={{ maxWidth: 'max-content', pointerEvents: withPointerEvents ? 'auto' : 'none' }}
          title={text}
          mouseEnterDelay={0.4}
          placement={placement}
          arrow={arrow}
        >
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '100%',
            }}
            className={className}
          >
            <Typography.Text ref={elemRef}>{text}</Typography.Text>
          </div>
        </Tooltip>
      </ConfigProvider>
    );
  }

  return (
    <div
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
      }}
      className={className}
    >
      <Typography.Text ref={elemRef}>{text}</Typography.Text>
    </div>
  );
};

export default EllipsizeText;
